import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "./config/api";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import "./Blog.css";
import FloatingAIButton from "./components/FloatingAIButton";
import Modal from "./Modal";
import { Helmet } from "react-helmet";

function Blog() {
  const [blogs, setBlogs] = useState([]);
  const navigate = useNavigate();
  const [isModalOpen, setModalOpen] = useState(false);

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  // Automatically open the modal after 5 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      openModal();
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    fetch(`${API_BASE_URL}/blogs`, requestOptions)
      .then((response) => response.json())
      .then((result) => setBlogs(result))
      .catch((error) => console.error("Error fetching blogs:", error));
  }, []);

  const handleReadMore = (blog) => {
    // Use slug if available, otherwise use ID as fallback
    if (blog.slug) {
      navigate(`/blog/${blog.slug}`);
    } else {
      console.warn("Blog without slug:", blog);
      navigate(`/blog/${blog._id}`);
    }
  };

  // Helper to strip HTML and truncate text
  const getExcerpt = (html, maxLength = 150) => {
    const tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    let text = tmp.textContent || tmp.innerText || "";
    if (text.length > maxLength) {
      text = text.substring(0, maxLength).trim() + "...";
    }
    return text;
  };

  // Filter only favorite and active blogs
  const filteredBlogs = blogs.filter(
    (blog) => blog.isFavorite && blog.isActive
  );

  return (
    <>
      <Helmet>
        <title>Travel Blogs | Trippro</title>
        <meta name="description" content="Explore travel stories, tips, and adventures from around the world on Trippro's travel blog." />
        <link rel="canonical" href="https://www.trippro.in/blog" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Travel Blogs | Trippro" />
        <meta property="og:description" content="Explore travel stories, tips, and adventures from around the world on Trippro's travel blog." />
        <meta property="og:url" content="https://www.trippro.in/blog" />
        <meta property="og:type" content="website" />
      </Helmet>
      <Navbar />

      {/* Hero Section */}
      <div className="blog-hero">
        <div className="blog-hero-overlay"></div>
        <div className="blog-hero-content">
          <h1>Our Travel Stories</h1>
          <p>Inspiring guides, tips, and adventures for your next journey.</p>
        </div>
      </div>

      <div className="blog-container">
        {filteredBlogs.map((blog) => (
          <div className="blog-card" key={blog._id}>
            <div className="blog-image-wrapper">
              <img src={blog.titleImage} alt={blog.title} loading="lazy" />
            </div>
            <div className="content">
              <h3 className="title">{blog.title}</h3>
              <p className="description">
                {getExcerpt(blog.description, 120)}
              </p>
              <button className="read-more-btn" onClick={() => handleReadMore(blog)}>
                Read Article
              </button>
            </div>
          </div>
        ))}
      </div>

      <Footer />

      {/* Floating box with image */}
      <FloatingAIButton onClick={openModal} />

      {/* Modal */}
      {isModalOpen && <Modal closeModal={closeModal} />}
    </>
  );
}

const styles = {
  floatingBox: {
    position: "fixed",
    bottom: "20px",
    right: "115px",
    width: "96px",
    height: "96px",
    display: "flex",
    borderRadius: "15px",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 10,
  },
  floatingButton: {
    border: "none",
    backgroundColor: "transparent",
    padding: 0,
    cursor: "pointer",
    borderRadius: "15px",
  },
  floatingImage: {
    width: "96px",
    height: "96px",
    objectFit: "cover",
    borderRadius: "15px",
  },
};

export default Blog;
